export const ENVIRONMENT_ENVS = ["LOCAL", "DEV", "DQS", "PROD"] as const;
